var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_8197)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#0A7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15.6403V17.6667C6 17.8534 6.14665 18 6.33329 18H8.35968C8.44633 18 8.53299 17.9667 8.59298 17.9L15.872 10.6277L13.3723 8.12801L6.09999 15.4004C6.03333 15.467 6 15.547 6 15.6403ZM17.8051 7.75472L16.2453 6.19494C16.1836 6.13314 16.1104 6.08412 16.0297 6.05067C15.9491 6.01722 15.8626 6 15.7753 6C15.688 6 15.6016 6.01722 15.521 6.05067C15.4403 6.08412 15.3671 6.13314 15.3054 6.19494L14.0856 7.41477L16.5852 9.91443L17.8051 8.6946C17.8669 8.63293 17.9159 8.55968 17.9493 8.47904C17.9828 8.3984 18 8.31196 18 8.22466C18 8.13736 17.9828 8.05092 17.9493 7.97028C17.9159 7.88964 17.8669 7.81639 17.8051 7.75472Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_8197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0014ee4553886955dede2f52efc444d1.svg";
export { ForwardRef as ReactComponent };